import { render, staticRenderFns } from "./ScrollDown.vue?vue&type=template&id=42fd68fd&scoped=true&"
import script from "./ScrollDown.vue?vue&type=script&lang=js&"
export * from "./ScrollDown.vue?vue&type=script&lang=js&"
import style0 from "./ScrollDown.vue?vue&type=style&index=0&id=42fd68fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fd68fd",
  null
  
)

export default component.exports